if (!customElements.get('pdp-media-gallery')) {
  customElements.define(
    'pdp-media-gallery',
    class PdpMediaGallery extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.swiper = null;
        this.zoomMode = this.dataset.imageZoom || 'lightbox';
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.mainEl = this.querySelector('[data-gallery-main]');
        this.slides = Array.from(this.mainEl.querySelectorAll('.swiper-slide'));

        const { signal } = this.abortController;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.mediaIndex)), { signal });
        });

        if (this.zoomMode !== 'none') {
          this.slides.forEach((slide) => {
            slide.addEventListener(
              'click',
              () => {
                // Swiper sets allowClick to false while dragging — only zoom on a real click/tap.
                if (this.swiper && !this.swiper.allowClick) return;
                this.openZoom(slide);
              },
              { signal }
            );
          });
        }

        // Swiper is loaded deferred, so it may not be defined yet when this runs.
        this.initSwiper();
        if (!this.swiper) {
          document.addEventListener('DOMContentLoaded', () => this.initSwiper(), { signal });
          window.addEventListener('load', () => this.initSwiper(), { signal });
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      initSwiper() {
        if (this.swiper || typeof Swiper === 'undefined' || this.slides.length < 2) return;

        // The is-current class drives the no-Swiper CSS fallback; Swiper takes over from here.
        const startIndex = Math.max(
          this.slides.findIndex((slide) => slide.classList.contains('is-current')),
          0
        );
        this.slides.forEach((slide) => slide.classList.remove('is-current'));

        this.swiper = new Swiper(this.mainEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: startIndex,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          on: {
            slideChange: (swiper) => this.setActiveThumb(swiper.activeIndex),
          },
        });
      }

      openZoom(slide) {
        if (this.zoomMode === 'none') return;

        const modal = document.querySelector(`#ProductModal-${this.dataset.section}`);
        if (!modal || typeof modal.showModal !== 'function') return;
        // The modal looks up its media by the opener's data-media-id attribute.
        modal.showModal(slide);
      }

      goTo(index) {
        if (this.swiper) {
          this.swiper.slideTo(index);
        } else {
          this.slides.forEach((slide, i) => slide.classList.toggle('is-current', i === index));
        }
        this.setActiveThumb(index);
      }

      setActiveThumb(index) {
        this.thumbs.forEach((thumb, i) => {
          const isActive = i === index;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
            thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
